import { frontendURL } from 'dashboard/helper/URLHelper';

import OnboardingPage from './OnboardingPage.vue';
import WelcomeView from './components/WelcomeView.vue';
import ChannelsView from './components/ChannelsView.vue';
import ChannelWhatsAppView from './components/ChannelWhatsAppView.vue';
import ChannelFacebookView from './components/ChannelFacebookView.vue';
import ChannelInstagramView from './components/ChannelInstagramView.vue';
import IntegrationsView from './components/IntegrationsView.vue';
import FinishView from './components/FinishView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wgpt-onboarding'),
      component: OnboardingPage,
      children: [
        {
          path: 'welcome',
          name: 'wgpt_onboarding',
          component: WelcomeView,
        },
        {
          path: 'channels',
          name: 'wgpt_onboarding_channels',
          component: ChannelsView,
        },
        {
          path: 'channels/whatsapp',
          name: 'wgpt_onboarding_channels_whatsapp',
          component: ChannelWhatsAppView,
        },
        {
          path: 'channels/facebook',
          name: 'wgpt_onboarding_channels_facebook',
          component: ChannelFacebookView,
        },
        {
          path: 'channels/instagram',
          name: 'wgpt_onboarding_channels_instagram',
          component: ChannelInstagramView,
        },
        {
          path: 'integrations',
          name: 'wgpt_onboarding_integrations',
          component: IntegrationsView,
        },
        {
          path: 'finish',
          name: 'wgpt_onboarding_finish',
          component: FinishView,
        },
      ],
    },
  ],
};
